import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Column, Contract, DatatableButton } from 'app/models';
import { AuthorizationService, ContractService } from 'app/services';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {
  public contracts: Contract[] = [];

  public columns: Column[] = [
    { property: 'prefix', label: 'CONTRACTS.PREFIX', type: 'string' },
    { property: 'name', label: 'CONTRACTS.NAME', type: 'string' }
  ];

  public adminColumns: Column[] = [
    { property: 'prefix', label: 'CONTRACTS.PREFIX', type: 'string' },
    { property: 'name', label: 'CONTRACTS.NAME', type: 'string' },
    { property: 'contractType', label: 'CONTRACTS.CONTRACTTYPE', type: 'string' }
  ];

  public buttons: DatatableButton[] = [];

  constructor(
    private readonly router: Router,
    private readonly authorizationService: AuthorizationService,
    private readonly contractService: ContractService
  ) {}

  public ngOnInit() {
    this.authorizationService.isLocationAdminAsync().subscribe(isLocationAdmin => {
      if (isLocationAdmin) {
        this.columns = this.adminColumns;
        this.contractService.getContracts().subscribe(contracts => this.setContracts(contracts));
      } else {
        this.setContracts(this.authorizationService.getContracts());
      }
    });
  }

  public isLocationAdmin() {
    return this.authorizationService.isLocationAdmin();
  }

  public goToContractIdLocationsPage(contractId: number) {
    this.router.navigate([`/locations/${contractId}`]);
  }

  public goToAllLocations() {
    this.router.navigate(['/admin/locations']);
  }

  private setContracts(contracts: Contract[]) {
    this.contracts = contracts;
    if (this.contracts.length === 1) {
      this.goToContractIdLocationsPage(this.contracts[0].id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/contracts/contracts.component.ts